import React from 'react'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3'
import { RECAPTCHA_SITE_KEY } from 'config/app'

const Recaptcha = ({ children }) => (
  <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY}>{children}</GoogleReCaptchaProvider>
)

export default Recaptcha
